// Zentrale Datenbasis der kostenlosen Leitfäden (Lead-Magnets) + Bibliotheks-Roadmap.
// Funnel-Seiten: /leitfaden/:slug · Übersicht: /leitfaeden

export const LEITFAEDEN = {
  "sturz-bewohner": {
    magnetId: "sturz-bewohner",
    preview: "/leitfaden-sturz-preview.webp",
    seoTitle: "Sturz eines Bewohners – was tun? Kostenloser Akutleitfaden | Dickies-Campus",
    seoDesc: "Kostenloser Leitfaden: Akutmaßnahmen der ersten 5 Minuten, rechtssichere Sturz-Dokumentation und das Angehörigen-Gespräch – sofort als PDF.",
    kicker: "Kostenlos · PDF · Sofort-Download",
    h1a: "Ein Bewohner ist gestürzt?",
    h1b: "In 5 Minuten alles richtig machen.",
    intro: "Der Akutleitfaden aus dem Dickies-Campus: die 7-Schritte-Kaskade für die ersten Minuten, alle roten Flaggen für den Notruf, das rechtssichere Sturzprotokoll mit Formulierungsbeispielen – und der 4-Schritte-Gesprächsleitfaden für die Angehörigen.",
    trust: [
      { icon: "clock", title: "Akut-Kaskade für die ersten 5 Minuten", desc: "Nie wieder unsicher: Was zuerst, was auf keinen Fall." },
      { icon: "shield", title: "Rechtssicher & MD-fest dokumentieren", desc: "8 Pflichtinhalte plus richtig/falsch-Formulierungen aus der Praxis." },
      { icon: "sparkles", title: "Sofort als PDF im Postfach", desc: "Kein Newsletter-Spam. Ein Dokument. Direkt einsatzbereit." },
    ],
    proof: "Pflegekräfte und PDLs nutzen diesen Leitfaden bereits im Nachtdienst.",
    quote: "„Seit der Leitfaden im Dienstzimmer hängt, ist beim Sturz niemand mehr kopflos. Sogar unsere Neuen wissen sofort, was zu tun ist.“",
    quoteAuthor: "Sandra K. · Wohnbereichsleitung · Essen",
    stats: [
      ["Akut-Checkliste", "7 Schritte"],
      ["Rote Flaggen", "6 Fälle"],
      ["Doku-Beispiele", "richtig / falsch"],
      ["Angehörigen-Gespräch", "4 Schritte"],
    ],
    bridge: "Plus MDK-Soforthilfe-Protokoll, Angehörigen-Mail-Templates und über 100 Mustervorlagen – wachsende Bibliothek, monatlich erweitert.",
  },
  "demenz-25-saetze": {
    magnetId: "demenz-25-saetze",
    preview: "/leitfaden-demenz-preview.webp",
    seoTitle: "Demenz: 25 Sätze, die wirklich helfen – kostenloser Leitfaden | Dickies-Campus",
    seoDesc: "25 erprobte Validation-Sätze für Unruhe, Pflegeverweigerung, „Ich will nach Hause“ und Aggression – kostenlos als PDF für dein Team.",
    kicker: "Kostenlos · PDF · Sofort-Download",
    h1a: "„Ich will nach Hause!“ – und jetzt?",
    h1b: "25 Sätze, die wirklich helfen.",
    intro: "Menschen mit Demenz erreichst du nicht über Logik, sondern über Gefühle. 25 erprobte Sätze aus Validation und personzentrierter Pflege für die 5 häufigsten Situationen – jeder Satz mit der Erklärung, warum er wirkt. Zum Ausdrucken fürs ganze Team.",
    trust: [
      { icon: "sparkles", title: "5 Situationen, 25 fertige Sätze", desc: "Unruhe, Pflegeverweigerung, Heimweh, Aggression, gute Momente." },
      { icon: "shield", title: "Mit „Warum es wirkt“", desc: "Du lernst das Prinzip dahinter – nicht nur die Worte." },
      { icon: "clock", title: "Plus 5 Sätze, die du streichen solltest", desc: "Die häufigsten Eskalations-Auslöser – und was du stattdessen sagst." },
    ],
    proof: "Der beliebteste Spickzettel im Dienstzimmer.",
    quote: "„‚Ich sehe, dass Sie sich ärgern‘ – dieser eine Satz hat mir mehr gebracht als jede Fortbildung davor. Die Bewohnerin war in zwei Minuten ruhig.“",
    quoteAuthor: "Miriam T. · Betreuungskraft § 43b · Dortmund",
    stats: [
      ["Fertige Sätze", "25"],
      ["Situationen", "5"],
      ["No-Go-Sätze", "5"],
      ["Grundregeln", "3"],
    ],
    bridge: "Vertiefung gefällig? Die Weiterbildung „Demenz & Kommunikation“ und der Dickies-Campus liefern Validation-Training, Fallbesprechungen und Angehörigen-Leitfäden.",
  },
  "md-pruefung-7-tage": {
    magnetId: "md-pruefung-7-tage",
    preview: "/leitfaden-md-preview.webp",
    seoTitle: "MD-Prüfung in 7 Tagen vorbereiten – kostenloser Plan | Dickies-Campus",
    seoDesc: "Der 7-Tage-Vorbereitungsplan für die MD-Qualitätsprüfung: Tagespläne, 30+ Checklisten-Punkte, Top-8-Abwertungsgründe – kostenlos als PDF.",
    kicker: "Kostenlos · PDF · Sofort-Download",
    h1a: "Der MD hat sich angekündigt?",
    h1b: "In 7 Tagen prüfungsbereit.",
    intro: "Der 7-Tage-Plan aus dem MDK-Schutzschild: jeden Tag ein Fokus (Stichprobe, Risikobereiche, Medikamente, Hygiene, Personal …), dazu die ersten 30 Minuten am Prüfungstag und die Top-8-Abwertungsgründe mit Gegenmittel.",
    trust: [
      { icon: "clock", title: "7 Tage, 7 machbare Etappen", desc: "60–90 Minuten pro Tag statt Panik-Wochenende." },
      { icon: "shield", title: "Auf QPR-Logik gebaut", desc: "Geprüft wird Ergebnisqualität am Bewohner – genau darauf bereitet der Plan vor." },
      { icon: "sparkles", title: "Top-8-Abwertungsgründe", desc: "Die häufigsten Fallen – und in welchem Tagesplan du sie entschärfst." },
    ],
    proof: "PDLs nutzen diesen Plan auch ohne Prüfungstermin – als Quartals-Routine.",
    quote: "„Wir haben den Plan einmal komplett durchgezogen. Ergebnis der Prüfung: keine einzige Abwertung in der Doku. Der Prüfer hat unser System gelobt.“",
    quoteAuthor: "Carsten B. · PDL ambulanter Dienst · Duisburg",
    stats: [
      ["Tagespläne", "7"],
      ["Checklisten-Punkte", "30+"],
      ["Abwertungsgründe", "Top 8"],
      ["Prüfungstag", "30-Min-Plan"],
    ],
    bridge: "Plus MDK-Soforthilfe-Protokoll (1-Pager), Notfall-Poster fürs PDL-Büro und der Fortbildungs-Tracker mit MD-fertigen Nachweis-PDFs – alles im Dickies-Campus.",
  },
  "leistungsgruppen-lg1-lg2": {
    magnetId: "leistungsgruppen-lg1-lg2",
    preview: "/leitfaden-lg-preview.webp",
    seoTitle: "Leistungsgruppen LG1 & LG2 im Überblick – kostenloses PDF für Arbeitgeber | Dickies-Campus",
    seoDesc: "Welche Tätigkeiten dürfen Mitarbeiter nach LG1- und LG2-Schulung übernehmen? Komplette Übersicht inkl. rechtlichem Rahmen und Team-Preisstaffel – kostenlos als PDF.",
    kicker: "Kostenlos · PDF · Für Arbeitgeber",
    h1a: "Was dürfen Ihre Mitarbeiter nach LG1 & LG2?",
    h1b: "Die komplette Übersicht.",
    intro: "Die Leistungsgruppen-Übersicht für Pflegedienste und Einrichtungen: alle delegierbaren Tätigkeiten der LG1 (Diagnostik, Medikation, Applikationen, Prophylaxe) und LG2 (Bilanzierung, Wundversorgung, Katheter & Sonden, therapeutische Anwendungen) – plus rechtlicher Rahmen und transparente Team-Preisstaffel.",
    trust: [
      { icon: "shield", title: "Rechtssicher delegieren", desc: "Klar abgegrenzte Kompetenzbereiche – inkl. Anforderungen an Anordnung und Dokumentation." },
      { icon: "sparkles", title: "Alle Tätigkeiten auf einen Blick", desc: "LG1 in 4 Kategorien, LG2 in 4 Kompetenzfeldern – zum Abheften ins QM-Handbuch." },
      { icon: "clock", title: "Mit Team-Preisstaffel", desc: "Bis zu 20 % Rabatt ab 10 Teilnehmern – MwSt.-befreit nach § 4 Nr. 21 UStG." },
    ],
    proof: "PDLs nutzen die Übersicht für Schulungsplanung und MD-Nachweise.",
    quote: "„Endlich eine Übersicht, die ich der Pflegekasse und dem MD direkt vorlegen kann. Unsere Schulungsplanung machen wir jetzt komplett danach.“",
    quoteAuthor: "Inhaber · ambulanter Pflegedienst · NRW",
    stats: [
      ["LG1-Kategorien", "4"],
      ["LG2-Kompetenzfelder", "4"],
      ["Rabatt ab 10 TN", "20 %"],
      ["Grundpreis", "1.499 €"],
    ],
    bridge: "Direkt qualifizieren: Die LG1/LG2-Schulung läuft 100 % online live, Start jeden Montag – buchbar für ganze Teams mit Rechnung an die Einrichtung.",
  },
  "abrechnungs-atlas": {
    magnetId: "abrechnungs-atlas",
    premium: true,
    preview: "/leitfaden-abrechnungs-atlas-preview.webp",
    seoTitle: "Abrechnungs-Atlas ambulante Pflege · 16 Bundesländer verifiziert · kostenlose Vollversion | Dickies-Campus",
    seoDesc: "16 Bundesländer mit Vertragsquelle belegt. Hero-Case mit amtlicher Auflösung. 3-Gruppen-Klassifizierung (NRW restriktiv vs. einsatzbezogene Systeme). 28 Seiten, kostenlos als PDF.",
    kicker: "Kostenlos · 28-Seiten-PDF · 16 BL verifiziert",
    h1a: "Wegepauschale morgens + abends?",
    h1b: "Der Atlas für alle 16 Bundesländer.",
    intro: "Der Atlas beantwortet die wichtigste Praxis-Frage in 3 Sekunden: Wie streng ist mein Bundesland? Mit Hero-Case aus einer echten PDL-Streitfrage (NRW · LK 15a max. 1× / Tag), 3-Gruppen-Klassifizierung aller 16 Bundesländer, Vertragsquellen pro Land (§ 75 oder § 89 SGB XI), Mustertext für Begründungen + Top-8-Kürzungsgründe mit Gegenmaßnahmen. 28 Seiten. Kostenlos. Per E-Mail im Postfach.",
    trust: [
      { icon: "shield", title: "16 Bundesländer · Vertragsquelle belegt", desc: "Jede LK-Definition, jede Kombi-Regel mit Rahmenvertrag § 75 oder Vergütungsvereinbarung § 89 SGB XI hinterlegt." },
      { icon: "sparkles", title: "Hero-Case mit amtlicher Auflösung", desc: "Echte PDL-Streitfrage zu morgens + abends LK 3 + LK 15a. Drei Meinungen aus der Community vs. Vertragstext." },
      { icon: "clock", title: "3-Gruppen-Klassifizierung", desc: "NRW = sehr restriktiv · HE/RP = mittel · 13 BL = einsatzbezogen. Praxis-Antwort in 3 Sekunden." },
    ],
    proof: "Geschrieben für Pflegedienste, die jede Kürzung der Pflegekasse satzweise prüfen.",
    quote: "„Endlich eine Übersicht, die mir nicht Bundesland für Bundesland gegoogelt werden muss. Spart in der Abrechnung jedes Mal eine halbe Stunde.“",
    quoteAuthor: "Inhaber · ambulanter Pflegedienst · NRW",
    stats: [
      ["Bundesländer", "16/16 belegt"],
      ["Seiten Vollversion", "28"],
      ["Stolperfallen", "Top 8 + Lösung"],
      ["Stand", "02 / 2026"],
    ],
    bridge: "Vorab reinblättern? Die 4-seitige Vorschau ist hier direkt: dickies-helden.de/abrechnungs-atlas-vorschau.pdf. Die Vollversion mit allen 16 Länderkapiteln kommt per E-Mail.",
  },
  "mdk-survival-guide": {
    magnetId: "mdk-survival-guide",
    premium: true,
    preview: "/leitfaden-mdk-survival-preview.webp",
    seoTitle: "MD-Prüfung-Survival-Guide ambulant · 23 Fragen, 7 No-Gos, 12 Kürzungsgründe · kostenlos | Dickies-Campus",
    seoDesc: "Was prüft der MD wirklich? 23 typische Fragen mit Hintergrund-Logik und Sofort-Antwort-Mustern, 7 No-Gos, 12 Kürzungsgründe mit Gegenmaßnahmen + 5-Seiten-Pflegegrad-Anhang. Kostenlos als PDF.",
    kicker: "Kostenlos · PDF · Für PDLs ambulant",
    h1a: "Der MD kommt in 14 Tagen?",
    h1b: "Survival-Guide für ambulante Pflegedienste.",
    intro: "Was prüft der Medizinische Dienst hinter den Standard-Formulierungen wirklich? Wo kürzt er am häufigsten? Der Survival-Guide gibt dir die 23 typischen MD-Fragen aus 5 Qualitätsbereichen – mit Hintergrund-Logik („was der Prüfer wirklich wissen will“) und fertigen Sofort-Antwort-Mustern im O-Ton der Praxis. Plus die 7 No-Gos, die zur direkten Abwertung führen, 12 häufigste Kürzungsgründe mit Gegenmaßnahmen und ein 5-Seiten-Anhang zur Pflegegrad-Begutachtung nach § 18 SGB XI.",
    trust: [
      { icon: "shield", title: "23 Fragen · 5 Qualitätsbereiche", desc: "Pflege & Risiko · Sturz & Notfall · Hygiene & Medi · Wundversorgung · Beratung & Einwilligung." },
      { icon: "sparkles", title: "Sofort-Antwort-Muster im O-Ton", desc: "Jede Antwort so formuliert, wie du sie der Prüferin direkt sagen kannst – ohne hilflos zu wirken." },
      { icon: "clock", title: "7 No-Gos + 12 Kürzungsgründe", desc: "Direkte Abwertungen erkennen und entschärfen, plus konkrete Gegenmaßnahmen für jeden Kürzungsgrund." },
    ],
    proof: "Geschrieben für ambulante Pflegedienste, die nach der Beschwerdeanlass-Prüfung wirklich vorbereitet sein wollen.",
    quote: "„13 Mängel in der ersten Prüfung. Nach dem zweiten Termin drei Monate später: null Mängel. Genau die Punkte aus diesem Guide haben den Unterschied gemacht.“",
    quoteAuthor: "PDL · ambulanter Pflegedienst · Ruhrgebiet (anonymisiert)",
    stats: [
      ["MD-Fragen", "23"],
      ["No-Gos", "7"],
      ["Kürzungsgründe", "12 + Lösung"],
      ["Pflegegrad-Anhang", "5 Seiten"],
    ],
    bridge: "Vertiefung im Helden-Hauptquartier: monatliche Live-Briefings zu QPR-Updates + MD-Direktkanal zu Fachdozenten bei laufenden Prüfungen.",
  },
  "kuerzungen-widerspruch": {
    magnetId: "kuerzungen-widerspruch",
    premium: true,
    preview: "/leitfaden-kuerzungen-widerspruch-preview.webp",
    seoTitle: "Pflegekassen-Kürzungen erfolgreich widersprechen · 12 Musterwidersprüche · kostenlos | Dickies-Campus",
    seoDesc: "12 typische Kürzungsgründe, fertige Musterwidersprüche zum Anpassen, Fristen-Übersicht nach SGB X und 3-Stufen-Eskalations-Plan bis zum Sozialgericht. Kostenlos als PDF.",
    kicker: "Kostenlos · PDF · Für PDLs & Abrechnung",
    h1a: "Pflegekasse kürzt schon wieder?",
    h1b: "So holst du dir das Geld zurück.",
    intro: "Der Cash-Verteidigungs-Guide für ambulante Pflegedienste: 12 typische Kürzungsgründe in 3 Gruppen (formell · inhaltlich · Doku), zu jedem ein sofort einsetzbarer Musterwiderspruch zum Anpassen, dazu Fristen-Übersicht nach SGB X und der 3-Stufen-Eskalations-Plan über Schiedsstelle (§ 76 SGB XI) bis zum Sozialgericht. Das ist die perfekte Cash-Ergänzung zum Abrechnungs-Atlas: Der Atlas zeigt, wo Kürzung droht – dieser Guide gibt dir die Werkzeuge, wie du sie zurückholst.",
    trust: [
      { icon: "shield", title: "12 fertige Musterwidersprüche", desc: "Pro Kürzungsgrund 1 sofort einsetzbarer Text – nur Datum, Az., Versicherte:r anpassen." },
      { icon: "sparkles", title: "Fristen + Eskalation komplett", desc: "1-Monats-Frist nach SGB X, Akteneinsicht, Schiedsstelle § 76 SGB XI, Klage am Sozialgericht – alles drin." },
      { icon: "clock", title: "Bundle mit dem Abrechnungs-Atlas", desc: "Atlas = wo droht Kürzung. Widerspruch-Guide = wie holst du sie zurück. Beide gratis im Campus." },
    ],
    proof: "Hero-Case im Guide: 2.640 € in 6 Wochen zurückgeholt – 4 von 5 Widersprüchen erfolgreich.",
    quote: "„Vier Widersprüche, vier Erfolge. Die Mustertexte musste ich nur anpassen. In sechs Wochen 2.640 € auf dem Konto – ohne Anwalt.“",
    quoteAuthor: "PDL · ambulanter Pflegedienst · NRW (anonymisiert)",
    stats: [
      ["Kürzungsgründe", "12"],
      ["Musterwidersprüche", "12 sofort einsetzbar"],
      ["Eskalations-Stufen", "3 bis Sozialgericht"],
      ["Seiten Vollversion", "16"],
    ],
    bridge: "Im Cash-Bundle mit dem Abrechnungs-Atlas (alle 16 Bundesländer) wird er zur vollständigen Verteidigungs-Routine – beide kostenlos im Dickies-Campus.",
  },
  "pflegegrad-spielbuch": {
    magnetId: "pflegegrad-spielbuch",
    premium: true,
    preview: "/leitfaden-pflegegrad-spielbuch-preview.webp",
    seoTitle: "Pflegegrad-Höherstufung erfolgreich beantragen · 6 Module + Mustertext · kostenlos | Dickies-Campus",
    seoDesc: "Pflegegrad zu niedrig? Das Spielbuch zeigt die 6 Begutachtungs-Module mit Punkten, die oft liegen bleiben, den 14-Tage-Plan und den Widerspruchs-Mustertext. Kostenlos als PDF.",
    kicker: "Kostenlos · PDF · Für Pflegekräfte & Angehörige",
    h1a: "Pflegegrad zu niedrig?",
    h1b: "Das ehrliche Spielbuch zur Höherstufung.",
    intro: "Der B2C-Leitfaden für Pflegekräfte (als Anwalt:innen ihrer Patient:innen) und Angehörige: die 6 Begutachtungs-Module des Medizinischen Dienstes im Detail, mit Punkten, die oft „liegen gelassen“ werden, ein 14-Tage-Vorbereitungs-Plan, ein Widerspruchs-Mustertext und Strategien für den Begutachtungstag. Ohne Tricks, ohne Übertreibung – aber mit dem Wissen, das die meisten Familien gar nicht haben.",
    trust: [
      { icon: "shield", title: "6 Module · alle Punkte sichtbar", desc: "Mobilität · Kognitiv · Verhalten · Selbstversorgung · Compliance · Alltag. Jede Falle, jeder Tipp." },
      { icon: "sparkles", title: "14-Tage-Vorbereitungs-Plan", desc: "Vom Tag 14 (Termin-Bestätigung) bis Termin-Tag eine konkrete Aufgabe – ohne Panik-Wochenende." },
      { icon: "clock", title: "Mustertext Widerspruch + Eskalation", desc: "Inkl. § 84 SGB X, Sonderfälle Demenz/Härtefall und Eskalations-Plan bis zum Sozialgericht." },
    ],
    proof: "Hero-Case: Pflegegrad 2 → Pflegegrad 3, +241 € Pflegegeld pro Monat (über das Jahr +2.892 €).",
    quote: "„Wir haben nichts erfunden – wir haben das gezeigt, was schon da war. Plötzlich war der Pflegegrad eindeutig zu niedrig. Mit dem Widerspruch kamen 241 € mehr im Monat.“",
    quoteAuthor: "Tochter eines Pflegebedürftigen · Sauerland (anonymisiert)",
    stats: [
      ["NBA-Module", "6"],
      ["Tage Vorbereitung", "14"],
      ["Hero-Case mehr Pflegegeld", "+2.892 €/Jahr"],
      ["Seiten Vollversion", "15"],
    ],
    bridge: "Ergänzend im Dickies-Campus: der MD-Survival-Guide für Pflegedienste, der Abrechnungs-Atlas (16 BL) und der Pflegekassen-Widerspruchs-Guide – alles kostenlos mit Helden-Basic.",
  },
  "haftungsfallen-pdl": {
    magnetId: "haftungsfallen-pdl",
    premium: true,
    preview: "/leitfaden-haftungsfallen-pdl-preview.webp",
    seoTitle: "Haftungsfallen 2026 für PDL & Geschäftsführung · 10 didaktische Lehrfälle + §§ + Templates · kostenlos | Dickies-Campus",
    seoDesc: "Wo PDLs persönlich haften können: 10 didaktische Lehrfälle auf Grundlage obergerichtlicher Rechtsprechungsgrundsätze, §§ aus BGB/StGB/SGB XI, 5 Sofort-Schutzmaßnahmen pro Falle + 5 Eskalations-Templates. Kostenlos als PDF.",
    kicker: "Kostenlos · PDF · Für PDLs & Geschäftsführung",
    h1a: "Gravierende MD-Mängel – und dann?",
    h1b: "Wo PDLs persönlich haften können (10 Lehrfälle).",
    intro: "Bei einer MD-Prüfung geht es nicht nur um Noten. Werden gravierende Mängel festgestellt, entstehen Haftungsrisiken für PDL und Geschäftsführung persönlich – mit privatem Vermögen, wenn die Berufshaftpflicht wegen grober Pflichtverletzung kürzt. Dieser Leitfaden zeigt an 10 frei erfundenen, didaktischen Lehrfällen (auf Grundlage obergerichtlicher Rechtsprechungsgrundsätze), wo Haftungsrisiken tatsächlich beginnen: Einarbeitung, Delegation, Medikamentenmanagement, Tourenplanung, Doku-Realität-Lücke. Pro Falle: fiktives Fallbeispiel, §§ Rechtsgrundlage (BGB/StGB/SGB XI/IfSG), 5 Sofort-Schutzmaßnahmen.",
    trust: [
      { icon: "shield", title: "10 didaktische Lehrfälle", desc: "Konkrete Szenarien, Konsequenzen, Beträge – frei erfunden, auf Grundlage obergerichtlicher Rechtsprechungsgrundsätze." },
      { icon: "sparkles", title: "§§ + 5 Schutzmaßnahmen pro Falle", desc: "BGB · StGB · SGB XI · IfSG. Plus konkrete Sofort-Schutzmaßnahmen für jede Falle." },
      { icon: "clock", title: "PDL-Checkliste + 5 Templates", desc: "Monatliche Checkliste, Überlastungsanzeige, Arzt-Info, Selbstanzeige bei Pflegekasse." },
    ],
    proof: "Geschrieben für PDLs, die ihre persönliche Haftung kennen – und reduzieren – wollen.",
    quote: "„Ich dachte immer, das wäre Pflegekraft-Sache. Nach diesem Leitfaden weiß ich, wo MEIN Risiko liegt – und wie ich es mit 60 Minuten pro Monat halbiere.“",
    quoteAuthor: "PDL · ambulanter Pflegedienst · Bayern (anonymisiert)",
    stats: [
      ["Haftungsfallen", "10"],
      ["Lehrfälle", "10 · didaktisch, fiktiv"],
      ["Schutzmaßnahmen", "50"],
      ["Eskalations-Templates", "5 sofort einsetzbar"],
    ],
    bridge: "Im MD-Schutzschild-Bundle mit Survival-Guide + 7-Tage-Plan – die Komplett-Verteidigung für die nächste MD-Prüfung. Plus monatliches Live-Briefing mit Fachanwalt Medizinrecht im Dickies-Campus.",
  },
  "wer-darf-was-atlas": {
    magnetId: "wer-darf-was-atlas",
    teaserPages: 17,
    premium: true,
    preview: "/leitfaden-wer-darf-was-atlas-preview.webp",
    seoTitle: "Wer darf was im Pflegedienst? Der Delegations-Atlas · alle 16 Bundesländer · 42 Tätigkeiten · 251 Seiten · Vorschau gratis | Dickies-Campus",
    seoDesc: "Die ehrliche Antwort für jede Behandlungspflege-Tätigkeit in deinem Bundesland: 8 Kategorien · 42 Tätigkeiten · 16-Bundesländer-Matrix · 7 Haftungsfallen pro Tätigkeit · 4-Label-Pre-Flight · Mustertexte. 17-Seiten-Vorschau gratis, Vollversion als Fachbuch-PDF (49,99 €).",
    kicker: "Fachbuch · PDF · 251 Seiten · 8 Kategorien · alle 16 Bundesländer · Vorschau gratis",
    h1a: "„Darf die Hilfskraft die Box stellen?“",
    h1b: "Der Delegations-Atlas für ALLE 16 Bundesländer.",
    intro: "Praxisanleiterin sagt „Mach mal“. MD-Prüfer fragt „Wer hat das freigegeben?“. Tochter ruft an „Meine Mutter hat die falsche Tablette bekommen!“. Drei Situationen, drei Rechtsgrundlagen, drei Haftungsebenen – und mit 16 Landes-Rahmenverträgen 16 mögliche Antworten. Dieser Atlas ordnet die Regelungen systematisch: über 8 Kategorien (Medikamentenmgmt · Injektionen · Kompression · Wundversorgung · Katheter · Ernährung · Atmung · Spezial) mit allen 42 Tätigkeiten, einer Bundesländer-Schnellmatrix pro Tätigkeit für ALLE 16 Bundesländer, 7 Haftungsfallen pro Tätigkeit (frei erfundene, didaktische Lehrfälle auf Grundlage obergerichtlicher Rechtsprechungsgrundsätze) und Mustertexten aus reiner Pflege-Perspektive. Plus Bonus „Wer darf was OHNE Delegation“. 251 Seiten · Redaktionsstand Juli 2026.",
    whatsNew: {
      version: "Update Juli 2026",
      title: "Neu: Wundversorgung · Katheter · Ernährung · Atmung · Spezialpflege",
      bullets: [
        "5 neue Kategorien (D–H) mit 25 Tätigkeiten – jetzt deckt der Atlas die komplette ambulante Behandlungspflege ab.",
        "Jetzt 251 Seiten · 16-Bundesländer-Matrix für jede einzelne Tätigkeit · Pre-Flight-Checkliste · Mustertexte.",
        "Die Vollversion gibt es als Fachbuch-PDF im Shop (49,99 €) – einmal kaufen, dauerhaft deins.",
      ],
    },
    trust: [
      { icon: "shield", title: "Alle 16 Bundesländer", desc: "Kapitel 2 mit Steckbriefen aller 16 Landes-Rahmenverträge (Stand, Helfer-Regel, Besonderheit, Quelle) + Bundesländer-Spezifika pro Tätigkeit." },
      { icon: "sparkles", title: "8 Kategorien · 42 Tätigkeiten", desc: "Medikamentenmanagement (A1–A7) · Injektionen (B1–B6) · Kompression (C1–C4) · Wundversorgung (D1–D6) · Katheter (E1–E5) · Ernährung (F1–F5) · Atmung (G1–G5) · Spezielle Behandlungspflege (H1–H4)." },
      { icon: "clock", title: "Pflege-Perspektive · 7 Lehrfälle pro Tätigkeit", desc: "16-BL-Matrix oder Bundesrechts-Block · 4-Label-Pre-Flight (Gesetz · Landesvertrag · MD-QM · Praxistipp) · Mustertexte · Eskalations-Brief Pflege→Arzt. Keine Arzt-/Apotheker-Inhalte." },
    ],
    proof: "Geschrieben für PDL, QM und Pflegefachkraft, die wissen wollen, wo die Delegation rechtssicher endet – und wo Haftung beginnt.",
    quote: "„Endlich eine klare Antwort, was meine Hilfskräfte in Bayern stellen dürfen – und was nicht. Die Matrix hängt jetzt im QM-Ordner.“",
    quoteAuthor: "PDL · ambulanter Pflegedienst · München (anonymisiert)",
    stats: [
      ["Kategorien", "8 (A–H)"],
      ["Tätigkeiten", "42 (alle)"],
      ["Bundesländer", "alle 16"],
      ["Seiten · Redaktionsstand Juli 2026", "251"],
    ],
    bridge: "Im Dickies-Campus: Live-Briefing „Wer darf was“ monatlich mit Fachanwalt Medizinrecht – Helden-Basic = 0 €. Die Atlas-Vollversion (251 Seiten) gibt es als Fachbuch-PDF im Shop.",
    vollversionTeaser: "Die <b>komplette 251-Seiten-Vollversion</b> mit allen 16 Bundesländern, 42 Tätigkeiten und allen Mustertexten",
    paidProduct: { url: "/shop/wer-darf-was-atlas", price: "49,99 €" },
  },
};

// --------------------------------------------------------------------------
// Bibliotheks-Roadmap: alle geplanten Leitfäden (Befüllvorschläge Juni 2026).
// `href` gesetzt = verfügbar · sonst „Bald verfügbar“.
// --------------------------------------------------------------------------
export const BIBLIOTHEK = [
  {
    category: "Angehörige & Patienten",
    items: [
      { title: "Pflegegrad-Höherstufung · Das Spielbuch", tags: ["6 NBA-Module", "14-Tage-Plan", "Widerspruchs-Mustertext"], href: "/leitfaden/pflegegrad-spielbuch" },
      { title: "Demenz. 25 Sätze, die wirklich helfen", tags: ["Formulierungen", "Praxisbeispiele"], href: "/leitfaden/demenz-25-saetze" },
      { title: "Angehörigen-Beschwerde · Mini-Leitfaden", tags: ["4-Schritte-System", "Mustertexte"], href: "/leitfaden/angehoerigen-beschwerde" },
    ],
  },
  {
    category: "Abrechnung & Wirtschaftlichkeit",
    items: [
      { title: "Abrechnungs-Atlas: 16 Bundesländer im Vergleich", tags: ["LK-Kombinationen", "Case Study Patient A", "MD-fest"], href: "/leitfaden/abrechnungs-atlas" },
      { title: "Pflegesatzverhandlung souverän führen", tags: ["Argumentations-Matrix", "Stolperfallen", "Vorbereitungs-Checkliste"] },
      { title: "Pflegekassen-Kürzungen erfolgreich widersprechen", tags: ["Musterwiderspruch", "Fristen", "Dokumentation"], href: "/leitfaden/kuerzungen-widerspruch" },
    ],
  },
  {
    category: "Beschwerden & Kommunikation",
    items: [
      { title: "Angehörigenbeschwerde professionell beantworten", tags: ["Musterantworten", "4-Schritte-System", "Deeskalation"], href: "/leitfaden/angehoerigen-beschwerde" },
      { title: "Wenn Angehörige mit dem Anwalt drohen", tags: ["Sofortmaßnahmen", "Formulierungsvorlagen", "Dokumentation"] },
      { title: "Beschwerdegespräch erfolgreich führen", tags: ["Gesprächsleitfaden", "Checkliste", "Fehler vermeiden"] },
      { title: "Negative Google-Bewertung erhalten?", tags: ["Antwortvorlagen", "Reputationsschutz", "Praxisbeispiele"] },
    ],
  },
  {
    category: "Personal & Führung",
    items: [
      { title: "Leistungsgruppen LG1 & LG2 im Überblick", tags: ["Delegierbare Tätigkeiten", "Rechtlicher Rahmen", "Team-Preisstaffel"], href: "/leitfaden/leistungsgruppen-lg1-lg2" },
      { title: "Mitarbeiter kündigt plötzlich. Was jetzt?", tags: ["Sofortplan", "Vertretungsstrategie", "Checkliste"] },
      { title: "Schwierige Mitarbeitergespräche führen", tags: ["Kritikgespräch", "Abmahnung", "Konfliktlösung"] },
      { title: "Krankmeldungen im Team reduzieren", tags: ["Ursachen erkennen", "Führungsinstrumente", "Maßnahmenplan"] },
      { title: "Neue Mitarbeiter erfolgreich einarbeiten", tags: ["30-Tage-Plan", "Checklisten", "Vorlagen"] },
    ],
  },
  {
    category: "Pflegedokumentation",
    items: [
      { title: "MD-Prüfung in 7 Tagen vorbereiten", tags: ["7-Tage-Plan", "Sofort-Checkliste", "Risikobereiche"], href: "/leitfaden/md-pruefung-7-tage" },
      { title: "MD-Prüfung-Survival-Guide ambulant", tags: ["23 typische Fragen", "7 No-Gos", "12 Kürzungsgründe"], href: "/leitfaden/mdk-survival-guide" },
      { title: "Dokumentation rechtssicher schreiben", tags: ["Die 10 häufigsten Fehler", "Praxisbeispiele"] },
      { title: "SIS in 15 Minuten verstehen", tags: ["Kurzanleitung", "Praxisbeispiele"] },
      { title: "Pflegefehler dokumentieren ohne Risiko", tags: ["Formulierungsbeispiele", "Rechtssicherheit"] },
    ],
  },
  {
    category: "Pflegealltag",
    items: [
      { title: "Sturz eines Bewohners. Was tun?", tags: ["Akutmaßnahmen", "Dokumentation", "Angehörigeninformation"], href: "/leitfaden/sturz-bewohner" },
      { title: "Bewohner verweigert Pflege", tags: ["Gesprächsleitfaden", "Dokumentation", "Praxislösungen"] },
      { title: "Gewalt in der Pflege erkennen", tags: ["Warnsignale", "Maßnahmen", "Dokumentation"] },
      { title: "Umgang mit aggressiven Bewohnern", tags: ["Sofortmaßnahmen", "Kommunikation", "Deeskalation"] },
    ],
  },
  {
    category: "Demenz",
    items: [
      { title: "Demenz. 25 Sätze, die wirklich helfen", tags: ["Formulierungen", "Praxisbeispiele"], href: "/leitfaden/demenz-25-saetze" },
      { title: "Weglauftendenz bei Demenz", tags: ["Risikomanagement", "Prävention", "Dokumentation"] },
      { title: "Angehörige von Menschen mit Demenz beraten", tags: ["Gesprächsleitfaden", "Häufige Fragen"] },
    ],
  },
  {
    category: "Pflegedienstleitung",
    items: [
      { title: "PDL in der Krise. Die ersten 48 Stunden", tags: ["Prioritätenliste", "Sofortplan"] },
      { title: "Dienstplan-Chaos vermeiden", tags: ["Sofortmaßnahmen", "Planungshilfen"] },
      { title: "Qualitätsprüfung angekündigt", tags: ["7-Tage-Vorbereitungsplan"], href: "/leitfaden/md-pruefung-7-tage" },
      { title: "Haftungsfallen 2026 für PDL &amp; Geschäftsführung", tags: ["10 Fälle", "§§ + Schutzmaßnahmen", "Premium"], href: "/leitfaden/haftungsfallen-pdl" },
      { title: "Fachkräftemangel. 15 Maßnahmen für mehr Bewerber", tags: ["Recruiting-Ideen", "Praxisbeispiele"] },
    ],
  },
  {
    category: "Arbeitsrecht",
    items: [
      { title: "Abmahnung rechtssicher formulieren", tags: ["Muster", "Formulierungen"] },
      { title: "Mitarbeiter kommt ständig zu spät", tags: ["Vorgehensweise", "Gesprächsleitfaden"] },
      { title: "Probezeit erfolgreich nutzen", tags: ["Checkliste für Führungskräfte"] },
    ],
  },
];


// =========================================================================
// MAGNET_COURSES · Empfehlung "passend zu diesem Leitfaden"
// =========================================================================
// Map magnetId → courseIds (in courses.js). Wird auf dem Funnel als
// "Passend dazu"-Stripe gerendert und treibt PDF-Downloader Richtung
// Weiterbildungs-Buchung (Hauptgeschäft).
//
// Verwendete Course-IDs siehe /app/frontend/src/data/courses.js
// =========================================================================
export const MAGNET_COURSES = {
  // B2B PDL-Heavy-Hitter → PDL, Praxisanleitung, LG1/LG2
  "wer-darf-was-atlas":   ["pflegeassistent-lg1-lg2", "pdl", "praxisanleitung"],
  "haftungsfallen-pdl":   ["pdl", "praxisanleitung", "pflegeassistent-lg1-lg2"],
  "abrechnungs-atlas":    ["pdl", "praxisanleitung", "pflegeassistent-lg1-lg2"],
  "mdk-survival-guide":   ["pdl", "praxisanleitung", "pflegeassistent-lg1-lg2"],
  "kuerzungen-widerspruch": ["pdl", "praxisanleitung"],
  "md-pruefung-7-tage":   ["pdl", "praxisanleitung"],

  // Pflegegrad-Schiene → Pflegeberater
  "pflegegrad-spielbuch": ["pflegeberater"],

  // Wundversorgung-Schiene → Wundexperte, Wundtherapeut
  "wundversorgung-basics": ["wundexperte", "wundtherapeut"],

  // Default für alle anderen → Einstieg + LG1/LG2 + PDL
  // (falls Magnet nicht im Mapping, nutzt das Frontend diesen Fallback)
  "_default":             ["pflegeassistent-lg1-lg2", "pdl", "ambulanter-pflegeassistent"],
};
